import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import CustomDialog from "../common/tableComponent.js/dialog";
import { networkProviderRequest } from "../common/customServiceCall/serviceCall";
import { useSelector } from "react-redux";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { InputSwitch } from "primereact/inputswitch";

export const ProviderNetwork = () => {
  const userDetails = useSelector((state) => state.login.userDetails);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [datetime24h, setDateTime24h] = useState(null);
  const [name, setName] = useState("");
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [modalName, setModalName] = useState("");
  const [apiMethod, setApiMethod] = useState("");

  // Add modal
  const [formData, setFormData] = useState({
    sendBoxApiUrl: "",
    sendBoxApiKey: "",
    liveApiUrl: "",
    liveApiKey: "",
    name: "",
    status: 0,
    liveStatusCheckUrl: "",
    shortNamePrefix: "",
    interfaceType: "",
    kycUrl: "",
    requestedBy: userDetails._id,
    requestedByName: userDetails.userName,
    approvedBy: userDetails._id,
    approvedByName: userDetails.userName,
  });

  const handleEditModalDisplay = (rowData) => {
    setModalName("Update Provider");
    setSelectedProvider(rowData);
    setApiMethod("put");
    console.log(rowData);
    setFormData({
      id: rowData.id,
      sendBoxApiUrl: rowData.sendBoxApiUrl || "N/A",
      sendBoxApiKey: rowData.sendBoxApiKey || "N/A",
      liveApiUrl: rowData.liveApiUrl || "N/A",
      liveApiKey: rowData.liveApiKey || "N/A",
      liveStatusCheckUrl: rowData.liveStatusCheckUrl || "N/A",
      shortNamePrefix: rowData.shortNamePrefix || "N/A",
      interfaceType: rowData.interfaceType || "N/A",
      name: rowData.name || "N/A",
      status: rowData.status || 0,
      requestedBy: rowData.requestedBy || "N/A",
      requestedByName: rowData.requestedByName || "N/A",
      approvedBy: rowData.approvedBy || "N/A",
      approvedByName: rowData.approvedByName || "N/A",
      kycUrl: rowData.kycUrl || "N/A",
    });
    setShowAddModal(true);
  };

  const handleAddModalDisplay = () => {
    setApiMethod("post");
    setModalName("Add Provider");
    setFormData({
      sendBoxApiUrl: "",
      sendBoxApiKey: "",
      liveApiUrl: "",
      liveApiKey: "",
      liveStatusCheckUrl: "",
      shortNamePrefix: "",
      interfaceType: "",
      kycUrl: "",
      requestedBy: userDetails._id,
      requestedByName: userDetails.userName,
      approvedBy: userDetails._id,
      approvedByName: userDetails.userName,
    });
    setShowAddModal(!showAddModal);
  };

  const handleViewModalDisplay = async (rowData) => {
    setSelectedProvider(rowData); // Set the selected provider data
    setShowViewModal(true); // Open the modal
  };

  const actions = (rowData) => (
    <>
      <Button
        label=""
        icon="pi pi-pencil"
        className="p-button-info p-mr-2"
        onClick={() => handleEditModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="Take Action"
        data-for="toolTip1"
        data-place="top"
      />
      <Button
        label=""
        icon="pi pi-eye"
        className="p-button-success p-mr-2"
        onClick={() => handleViewModalDisplay(rowData)}
        style={{ fontSize: "15px", padding: "7px" }}
        data-tip="View Details"
        data-for="toolTip1"
        data-place="top"
      />
    </>
  );

  const fetchData = async () => {
    setLoading(true); // Start loading

    const requestData = {
      created_at: datetime24h ? datetime24h.toISOString() : "",
      name: name || "", // Update with state
      size: "9999999",
    };
    const filteredRequestData = Object.fromEntries(
      Object.entries(requestData).filter(([key, value]) => value !== "")
    );

    const queryString = new URLSearchParams(filteredRequestData).toString();
    try {
      const response = await networkProviderRequest(
        "get",
        `api/v1/networkandprovider/provider/filter?${queryString}`
      );
      if (response.code === "00") {
        const fetchedData = response.data;
        console.log(fetchedData);
        setCustomers(fetchedData);
      } else {
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchData();
  }, [datetime24h, name]); // Re-fetch data when filters change

  const getSearchedData = () => {
    fetchData(); // Re-fetch the data with the updated filters
  };

  const cardStyle = { borderRadius: "40px" };

  const labelStyleLeft = { fontSize: "14px" };

  const labelStyleRight = {
    fontSize: "14px",
    float: "left",
    fontWeight: "500",
  };

  const handleSubmit = async () => {
    try {
      setLoading(true); // Start loading
      const response = await networkProviderRequest(
        apiMethod,
        "api/v1/networkandprovider/provider",
        formData
      );
      console.log("naps", response);
      if (response.code === "00") {
        // Successfully added provider
        setShowAddModal(false); // Close the modal
        fetchData(); // Refresh the table data
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          life: 3000, // Duration of the toast in milliseconds
        });
      } else {
        console.error("Failed to add provider:", response.message);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: response.message,
          life: 3000,
        });
      }
    } catch (error) {
      console.error("Error adding provider:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error adding provider",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const interfaceTypeOptions = [
    { label: "WEB", value: "WEB" },
    { label: "BROKER", value: "BROKER" },
  ];

  return (
    <section className="p-my-4 p-md-12 p-xl-12" style={{ padding: "0px 10%" }}>
      <Toast ref={toast} />

      <div className="p-grid p-fluid">
        <div
          className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
          style={{ textAlign: "center" }}
        >
          <span className="p-tag custom-heading">Provider</span>
        </div>
      </div>

      <div className="card" style={{ paddingTop: "0px" }}>
        <div className="p-col-12 " style={{ paddingTop: "30px" }}>
          <div className="p-grid p-justify-between p-fluid">
            <div className="p-field p-col-6 p-md-3">
              <span className="p-float-label">
                <Calendar
                  id="calendar-24h"
                  value={datetime24h}
                  onChange={(e) => {
                    setDateTime24h(e.value);
                    fetchData();
                  }}
                  showTime
                  showIcon={true}
                  hourFormat="24"
                  placeholder="Date Created At"
                />
              </span>
            </div>

            <div className="p-col-12 p-md-4 p-xl-4">
              <div className="p-grid">
                <div className="" style={{ paddingLeft: "0.4px" }}>
                  <div className="p-inputgroup">
                    <InputText
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter Name"
                    />
                    <Button
                      onClick={getSearchedData}
                      icon="pi pi-search"
                      className="p-button-info"
                    />
                    <Button
                      icon="pi pi-plus"
                      onClick={handleAddModalDisplay}
                      className="p-button-info"
                      style={{ fontSize: "15px", marginLeft: "10px" }}
                      data-tip="Add User"
                      data-for="toolTip1"
                      data-place="top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <ProgressSpinner
              style={{
                display: userDetails.showLoader,
                width: "40px",
                height: "40px",
                position: "fixed",
                top: "50%",
                left: "50%",
                bottom: "50%",
                right: "50%",
                zIndex: "1111111111",
              }}
              strokeWidth="3"
              animationDuration=".5s"
            />
          </div>
        ) : (
          <DataTable
            value={customers}
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 25, 50]}
            tableStyle={{ minWidth: "50rem" }}
          >
            <Column
              field="sendBoxApiUrl"
              header="SandBox Api Url"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="liveApiUrl"
              header="Live Api Url"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="name"
              header="Name"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="requestedByName"
              header="Requested By Name"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="approvedByName"
              header="Approved By Name"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="interfaceType"
              header="Interface Type"
              style={{ width: "25%" }}
            ></Column>
            <Column
              field="status"
              header="Status"
              style={{ width: "25%" }}
            ></Column>

            <Column
              header="Actions"
              style={{ width: "25%" }}
              body={actions}
            ></Column>
          </DataTable>
        )}
      </div>
      <>
        <CustomDialog
          visible={showViewModal}
          header="View Provider Modal"
          onClose={() => setShowViewModal(false)}
        >
          {selectedProvider && (
            <div
              className="p-grid p-fluid transaction"
              style={{ height: "70vh", overflowY: "scroll" }}
            >
              <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                <div style={cardStyle}>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Sandbox Api Url</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.sendBoxApiUrl || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Sandbox Api Key</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.sendBoxApiKey || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Live Api Url</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.liveApiUrl || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Live Api Key</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.liveApiKey || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>
                        Live Status Check Url
                      </label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.liveStatusCheckUrl || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Short Name Prefix</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.shortNamePrefix || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}> Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.name || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>KYC Url</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.kycUrl || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Status</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.status || "N/A"}
                      </label>
                    </div>
                  </div>

                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Interface Type</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.interfaceType || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Requested By</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.requestedBy || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Requested By Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.requestedByName || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Approved By</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.approvedBy || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Approved By Name</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.approvedByName || "N/A"}
                      </label>
                    </div>
                  </div>
                  <div className="p-grid">
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleLeft}>Created On</label>
                    </div>
                    <div className="p-col-6 p-md-6 p-lg-6 p-xl-6 profileTop">
                      <label style={labelStyleRight}>
                        {selectedProvider.createdOn || "N/A"}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </CustomDialog>
        <CustomDialog
          visible={showAddModal}
          header={modalName}
          onClose={() => setShowAddModal(false)}
        >
          <div
            className="p-grid p-fluid"
            style={{ height: "70vh", overflowY: "scroll" }}
          >
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="sendBoxApiUrl">Send Box API URL</label>
                <InputText
                  id="sendBoxApiUrl"
                  value={formData.sendBoxApiUrl}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      sendBoxApiUrl: e.target.value,
                    })
                  }
                  placeholder="Enter Send Box API URL"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="sendBoxApiKey">Send Box API Key</label>
                <InputText
                  id="sendBoxApiKey"
                  value={formData.sendBoxApiKey}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      sendBoxApiKey: e.target.value,
                    })
                  }
                  placeholder="Enter Send Box API Key"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="liveApiUrl">Live API URL</label>
                <InputText
                  id="liveApiUrl"
                  value={formData.liveApiUrl}
                  onChange={(e) =>
                    setFormData({ ...formData, liveApiUrl: e.target.value })
                  }
                  placeholder="Enter Live API URL"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="liveApiKey">Live API Key</label>
                <InputText
                  id="liveApiKey"
                  value={formData.liveApiKey}
                  onChange={(e) =>
                    setFormData({ ...formData, liveApiKey: e.target.value })
                  }
                  placeholder="Enter Live API Key"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="liveStatusCheckUrl">
                  Live Status Check URL
                </label>
                <InputText
                  id="liveStatusCheckUrl"
                  value={formData.liveStatusCheckUrl}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      liveStatusCheckUrl: e.target.value,
                    })
                  }
                  placeholder="Enter Live Status Check URL"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="interfaceType">Interface</label>
                <Dropdown
                  value={formData.interfaceType}
                  onChange={
                    (e) => setFormData({ ...formData, interfaceType: e.value }) // e.value will contain the 'value' of the selected option
                  }
                  options={interfaceTypeOptions}
                  optionLabel="label"
                  placeholder="Select interfaceType"
                  className="w-full md:w-14rem"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="name">Name</label>
                <InputText
                  id="name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                  placeholder="Enter Name"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field p-grid p-mx-1">
                <label htmlFor="status p-mt-2">Status</label>
                <InputSwitch
                  id="status"
                  checked={formData.status === 1} // Checked when status is 0
                  onChange={(e) =>
                    setFormData({ ...formData, status: e.value ? 1 : 0 })
                  } // Update formData.status
                  style={{ margin: "0px 10px" }}
                />
              </div>
            </div>

            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="shortNamePrefix">Short Name Prefix</label>
                <InputText
                  id="shortNamePrefix"
                  value={formData.shortNamePrefix}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      shortNamePrefix: e.target.value,
                    })
                  }
                  placeholder="Enter Short Name Prefix"
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="p-field">
                <label htmlFor="kycUrl">KycUrl</label>
                <InputText
                  id="kycUrl"
                  value={formData.kycUrl}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      kycUrl: e.target.value,
                    })
                  }
                  placeholder="Enter kycUrl"
                />
              </div>
            </div>
          </div>

          <div className="p-grid">
            <div className="p-col-12 p-grid p-justify-end">
              <Button
                label={apiMethod === "post" ? "Add" : "Update"}
                onClick={handleSubmit}
                className="p-button-info"
                style={{ width: "25%", marginTop: "1.5em" }}
              />
            </div>
          </div>
        </CustomDialog>
      </>
    </section>
  );
};
